import { styled } from '@mui/system';
import {
  Box,
  Container,
  Typography,
  Grid,
  FormControl,
  Skeleton,
  Button,
  MenuItem,
} from '@mui/material';
import { COLORS } from './constants';
import { fontFamilies, colors } from '../../../../../constants/theme';
import { SectionHeading } from '../../styles';
import CTAButton from '../../../../../ui/ctaButton';

export const SectionContainer = styled(Box)(({ theme }) => ({
  padding: '0',
  maxWidth: '1100px',
  marginLeft: 'auto',
  marginRight: 'auto',
}));

export const ContentContainer = styled(Container)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  maxWidth: '1120px',
  padding: '0',
});

export const SectionTitle = styled(SectionHeading)(({ theme }) => ({
  ...theme.typography.heading,
  textAlign: 'center',
  fontSize: 50,
  fontWeight: 400,
  fontFamily: fontFamilies.gotham,
  lineHeight: '58px',
}));

export const FilterFormControl = styled(FormControl)(({ theme }) => ({
  '& .MuiInputLabel-root': {
    fontFamily: fontFamilies.quicksand,
    fontWeight: 400,
    fontSize: '18px',
    color: COLORS.SUBTEXT,
    opacity: '.6',
    transform: 'translate(14px, 19px) scale(1)',
    [theme.breakpoints.down('md')]: {
      fontSize: '16px',
      transform: 'translate(14px, 17px) scale(1)',
      lineHeight: '20px',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
      transform: 'translate(14px, 16px) scale(1)',
      lineHeight: '15px',
    },
    '&.Mui-focused': {
      color: COLORS.SUBTEXT,
    },
    '&.MuiInputLabel-shrink': {
      opacity: 1,
      transform: 'translate(14px, -8px) scale(0.75)',
    },
  },
  '& .MuiOutlinedInput-root': {
    width: '204px',
    minHeight: '64px',
    borderRadius: '23px',
    backgroundColor: '#fff',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
    fontFamily: fontFamilies.quicksand,
    fontWeight: 400,
    fontSize: '18px',
    letterSpacing: '0.02em',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      fontSize: '16px',
      minHeight: '56px',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
      minHeight: '48px',
      width: '180px',
    },
    '& .MuiSelect-select': {
      display: 'flex',
      alignItems: 'center',
      paddingTop: '0 !important',
      paddingBottom: '0 !important',
      minHeight: '64px',
      height: '100%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      [theme.breakpoints.down('md')]: {
        minHeight: '56px',
      },
      [theme.breakpoints.down('sm')]: {
        minHeight: '48px',
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
  },
}));

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  fontFamily: fontFamilies.quicksand,
  fontSize: '18px',
  [theme.breakpoints.down('md')]: {
    fontSize: '16px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '14px',
  },
}));

export const FiltersGridContainer = styled(Grid)(({ theme }) => ({
  justifyContent: 'center',
  maxWidth: '1110px',
  gap: '20px',
  marginTop: '50px',
}));

export const FiltersGrid = styled(FiltersGridContainer)(({ theme }) => ({
  minWidth: '0',
  maxWidth: '204px',
  marginTop: '0',
}));

export const TeamGrid = styled(Grid)({
  justifyContent: 'center',
  maxWidth: '1100px',
  margin: '50px 0',
  gap: '20px',
});

export const TeamMemberGrid = styled(Grid)({
  display: 'flex',
  justifyContent: 'center',
  flexShrink: 0,
  boxShadow: '0 8px 24px rgba(0, 0, 0, 0.08)',
  borderRadius: '16px',
});

export const TeamMemberCard = styled(Box)(({ theme }) => ({
  textAlign: 'left',
  width: '353px',
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
  position: 'relative',
  borderRadius: '16px',
  boxShadow: '0 8px 24px rgba(0, 0, 0, 0.08)',
  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  height: '100%',
  '&:hover': {
    transform: 'scale(1.02)',
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.08)',
    zIndex: 10,
  },
  '&:hover .card-link': {
    opacity: 1,
  },
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    maxWidth: '333px',
  },
}));

export const MemberImage = styled('img')({
  width: '353px',
  height: '353px',
  objectFit: 'cover',
  objectPosition: 'top',
  border: 'none',
  display: 'block',
  flexShrink: 0,
  borderRadius: '16px 16px 0 0',
  background: '#E6EBF0',
});

export const MemberInfoWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  padding: '23px 16px',
  gap: '10px',
  background: '#E6EBF0',
  borderRadius: '0 0 16px 16px',
  flexGrow: 1,
});

export const MemberName = styled(Typography)({
  fontFamily: fontFamilies.gotham,
  fontSize: '23px',
  fontWeight: 500,
  color: colors.primary,
  lineHeight: '24px',
});

export const MemberTitle = styled('span')({
  fontFamily: fontFamilies.quicksand,
  fontSize: '14px',
  fontWeight: 600,
  color: colors.primary,
  lineHeight: '20px',
  display: 'inline-block',
});

export const MemberInfo = styled(Typography)({
  fontFamily: fontFamilies.quicksand,
  fontSize: '14px',
  fontWeight: 400,
  color: colors.primary,
  lineHeight: '20px',
  marginTop: '5px',
});

export const CardLink = styled(Button)(({ theme }) => ({
  ...theme.typography.gotham,
  fontSize: '15px',
  lineHeight: '24px',
  fontWeight: 500,
  display: 'inline-block',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  cursor: 'pointer',
  position: 'absolute',
  top: '295px',
  textDecoration: 'none',
  color: colors.text,
  background: colors.whiteText,
  width: '230px',
  left: '50%',
  transform: 'translateX(-50%)',
  opacity: 0,
  borderRadius: '8px',
  transition: 'all 0.3s ease',
  zIndex: 10,
  '&.MuiButtonBase-root': {
    '&:focus': {
      outline: 'none',
      boxShadow: 'none',
    },
    '&:focus-visible': {
      outline: 'none',
      boxShadow: 'none',
    },
    '&:hover': {
      background: colors.whiteText,
      transform: 'translateX(-50%) scale(1.04)',
    },
    '&:active': {
      background: colors.calmBlue,
      color: colors.whiteText,
    },
  },
}));

export const LoadMoreContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(4),
  textAlign: 'center',
  margin: '0 auto',
  width: '100%',
  maxWidth: '1100px',
  [theme.breakpoints.down('1139')]: {
    maxWidth: '726px',
  },
  [theme.breakpoints.down('766')]: {
    maxWidth: '353px',
  },
  [theme.breakpoints.up('md')]: {
    marginTop: theme.spacing(5),
  },
}));

export const LoadMoreButton = styled(CTAButton)(({ theme }) => ({
  width: '100%',
}));

export const StateMessageContainer = styled(Container)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '16px',
  margin: '220px auto 150px',
  [theme.breakpoints.down('lg')]: {
    margin: '70px auto 180px',
  },
  [theme.breakpoints.down('xs')]: {
    margin: '100px auto 50px',
  },
}));

export const StateMessage = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtext,
  textAlign: 'center',
  fontSize: '23px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '20px',
  },
}));

export const SkeletonCard = styled(Box)(({ theme }) => ({
  textAlign: 'left',
  width: '353px',
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
  position: 'relative',
  borderRadius: '16px',
  boxShadow: '0 8px 24px rgba(0, 0, 0, 0.08)',
  height: '100%',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    maxWidth: '333px',
  },
}));

export const SkeletonImage = styled(Skeleton)(({ theme }) => ({
  width: '353px',
  height: '353px',
  borderRadius: '16px 16px 0 0',
  transform: 'none',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    maxWidth: '333px',
  },
}));

export const SkeletonInfoWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  padding: '23px 16px',
  gap: '10px',
  background: '#E6EBF0',
  borderRadius: '0 0 16px 16px',
  flexGrow: 1,
});

export const SkeletonName = styled(Skeleton)({
  width: '200px',
  height: '24px',
});

export const SkeletonTitle = styled(Skeleton)({
  width: '180px',
  height: '20px',
});

export const SkeletonInfo = styled(Skeleton)({
  width: '100%',
  height: '20px',
  marginTop: '5px',
});

export const SkeletonLink = styled(Skeleton)({
  width: '100px',
  height: '20px',
  marginTop: '10px',
});

export const BookConsultationButton = styled('button')(({ theme }) => ({
  color: colors.secondary,
  fontFamily: fontFamilies.quicksand,
  fontSize: '14px',
  fontWeight: 500,
  textTransform: 'none',
  whiteSpace: 'nowrap',
  maxWidth: 360,
  padding: '0',
  background: 'transparent',
  border: 'none',
  cursor: 'pointer',
  justifyContent: 'end',
  marginTop: 'auto',
  width: 'fit-content',
  alignSelf: 'flex-end',
  textDecoration: 'underline',
  paddingTop: '15px',
}));
